<div class="rs-spinner">
  <mat-spinner color="warn"></mat-spinner>
</div>
